// import { useState, useEffect } from "react";

// function Search({ songs }) {
//   const [query, setQuery] = useState("");
//   const [results, setResults] = useState([]);
//   const [debouncedQuery, setDebouncedQuery] = useState("");

//   // Debounce logic
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedQuery(query);
//     }, 500);

//     return () => clearTimeout(handler);
//   }, [query]);

//   // FRONTEND FILTER
//   useEffect(() => {
//     if (!debouncedQuery) {
//       setResults([]);
//       return;
//     }

//     const filtered = songs.filter((song) =>
//       song.title.toLowerCase().includes(debouncedQuery.toLowerCase())
//     );

//     setResults(filtered);
//   }, [debouncedQuery, songs]);

//   return (
//     <div style={{ position: "relative" }}>
//       <input
//         type="text"
//         placeholder="Search a song..."
//         value={query}
//         onChange={(e) => setQuery(e.target.value)}
//         style={{
//           padding: "8px 12px",
//           borderRadius: "4px",
//           border: "1px solid #ccc",
//           width: "300px",
//         }}
//       />

//       {debouncedQuery && (
//         <div
//           style={{
//             position: "absolute",
//             background: "#181818",
//             width: "100%",
//             maxHeight: "300px",
//             overflowY: "auto",
//             marginTop: "4px",
//             borderRadius: "4px",
//             padding: "10px",
//             color: "white",
//           }}
//         >
//           {results.length > 0 ? (
//             results.map((song) => (
//               <div
//                 key={song.id}
//                 style={{
//                   padding: "8px",
//                   cursor: "pointer",
//                   borderBottom: "1px solid #333",
//                 }}
//               >
//                 {song.title}
//               </div>
//             ))
//           ) : (
//             <div style={{ padding: "8px" }}>No songs found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// export default Search;

import React from "react";
import styles from "./Search.module.css";
import { ReactComponent as SearchIcon } from "../assets/search-icon.svg";
import {useAutocomplete} from "@mui/base/useAutocomplete"; 
import { styled } from "@mui/system";
import { truncate } from "../helpers/helpers";
import { useNavigate } from "react-router-dom";
// import { Tooltip } from "@mui/material";

const Listbox = styled("ul")(({ theme }) => ({
  width: "100%",
  margin: 0,
  padding: 0,
  position: "absolute",
  borderRadius: "0px 0px 10px 10px",
  border: "1px solid var(--color-primary)",
  top: 60,
  height: "max-content",
  maxHeight: "500px",
  zIndex: 10,
  overflowY: "scroll",
  left: 0,
  bottom: 0,
  right: 0,
  listStyle: "none",
  backgroundColor: "var(--color-black)",
  overflow: "auto",
  "& li.Mui-focused": {
    backgroundColor: "#4a8df6",
    color: "white",
    cursor: "pointer",
  },
  "& li:active": {
    backgroundColor: "#2977f5",
    color: "white",
  },
}));

function Search({ searchData, placeholder }) {
  const {
    getRootProps,
    // getInputLabelProps,
    value,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
  } = useAutocomplete({
    id: "use-autocomplete-demo",
    options: searchData || [],
    getOptionLabel: (option) => option.title,
  });

  const navigate = useNavigate();
  const onSubmit = (e, value) => {
    e.preventDefault();
    console.log(value);
    navigate(`/album/${value.slug}`);
    //Process form data, call API, set state etc.
  };

  return (
    <div style={{ position: "relative" }}>
      <form
        className={styles.wrapper}
        onSubmit={(e) => {
          onSubmit(e, value);
        }}
      >
        <div {...getRootProps()}>
          <input
            name="album"
            className={styles.search}
            placeholder={placeholder}
            required
            {...getInputProps()}
          />
        </div>
        <div>
          <button className={styles.searchButton} type="submit">
            <SearchIcon />
          </button>
        </div>
      </form>
      {groupedOptions.length > 0 ? (
        <Listbox {...getListboxProps()}>
          {groupedOptions.map((option, index) => {
            // console.log(option);
            const artists = option.songs.reduce((accumulator, currentValue) => {
              accumulator.push(...currentValue.artists);
              return accumulator;
            }, []);

            return (
              <li
                className={styles.listElement}
                {...getOptionProps({ option, index })}
              >
                <div>
                  <p className={styles.albumTitle}>{option.title}</p>

                  <p className={styles.albumArtists}>
                    {truncate(artists.join(", "), 40)}
                  </p>
                </div>
              </li>
            );
          })}
        </Listbox>
      ) : null}
    </div>
  );
}

export default Search;
